import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { emptyEmployee } from "../../redux/employeeSlice";
import { Logout } from "../../redux/userSlice";

const AutoLogout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const timerRef = useRef(null);

  const handleLogout = () => {
    dispatch(Logout());
    dispatch(emptyEmployee());
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      handleLogout();
    }, 15 * 60 * 1000); // 5 minutes
  };

  useEffect(() => {
    // activity events jaha user interact karta hai
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // initial timer set
    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []); // optional (location) dependency route change hone pr bhi reset hoga

  return <>{children}</>;
};

export default AutoLogout;
